import axios from 'axios';

export default class AxiosHttpClient {
  #client;

  constructor(config) {
    this.#client = axios.create(config);
  }

  get(url, config = {}) {
    return this.#client.get(url, config);
  }

  post(url, config = {}) {
    return this.#client.post(url, config);
  }

  put(url, data, config = {}) {
    return this.#client.put(url, data, config);
  }
}
